<template>
    <v-dialog
        v-model="dialogo"
        :max-width="opciones.width"
        :style="{ zIndex: opciones.zIndex }"
        @keydown.esc="cancelar"
    >
        <v-card>
            <v-toolbar :color="opciones.color" density="compact" flat>
                <v-toolbar-title class="text-white">
                    {{ titulo }}
                </v-toolbar-title>
            </v-toolbar>
            <v-card-text class="pa-4 text-grey text-body-1">
                <div v-html="mensaje"></div>
            </v-card-text>
            <v-card-actions class="d-flex flex-row justify-center">
                <v-btn
                    color="primary"
                    class="text--text mx-2"
                    variant="outlined"
                    @click="cancelar"
                    >{{ t("boton-cancelar") }}</v-btn
                >
                <v-btn
                    color="primary"
                    class="mx-2"
                    variant="flat"
                    @click="confirmar"
                    >{{ t("boton-aceptar") }}</v-btn
                >
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script setup>
import { ref, reactive } from "vue";
import { useI18n } from "vue-i18n";

defineOptions({
    name: "ConfirmDlg",
});

const { t } = useI18n();

const dialogo = ref(false);
const resolvePromise = ref(null);
const rejectPromise = ref(null);
const mensaje = ref(null);
const titulo = ref(null);
const opciones = reactive({
    color: "primary",
    width: 400,
    zIndex: 200,
});

const abrir = (tituloVal, mensajeVal, opcionesVal) => {
    dialogo.value = true;
    titulo.value = tituloVal;
    mensaje.value = mensajeVal;
    Object.assign(opciones, opcionesVal);

    return new Promise((resolve, reject) => {
        resolvePromise.value = resolve;
        rejectPromise.value = reject;
    });
};

const confirmar = () => {
    if (resolvePromise.value) {
        resolvePromise.value(true);
    }
    dialogo.value = false;
};

const cancelar = () => {
    if (resolvePromise.value) {
        resolvePromise.value(false);
    }
    dialogo.value = false;
};

defineExpose({ abrir });
</script>
